'use client';

import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import { cn } from '@wwe-portal/ui/lib/lib';
import { useState } from 'react';
import { TextAvatar } from './text-avatar';
import Image, { ImageProps } from 'next/image';
import { FactionLink } from '../link/faction-link';
import { API_ENDPOINT_NEST } from '@wwe-portal/web/utils/config';

interface FactionAvatarContentProps {
  factionId?: string;
  factionName: string | undefined;
  className?: string;
  imageProps?: ImageProps;
  asLink?: boolean; // default is true
}

const FactionAvatarContent: React.FC<FactionAvatarContentProps> = ({
  factionId,
  factionName,
  className,
  imageProps,
}) => {
  const [isError, setIsError] = useState(false);
  if (!factionId)
    return (
      <Skeleton className={cn('overflow-hidden rounded-full', className)} />
    );
  if (isError)
    return (
      <TextAvatar
        className={cn(
          'flex h-full w-full items-center justify-center overflow-hidden rounded-full',
          className
        )}
        text={(factionName ?? factionId).toString()}
      />
    );
  return (
    <Image
      className={cn('overflow-hidden rounded-full', className)}
      src={`${API_ENDPOINT_NEST}/v2/images/faction/${factionId}.jpg`}
      alt="faction avatar"
      onError={() => setIsError(true)}
      width={32}
      height={32}
      priority={false}
      {...imageProps}
    />
  );
};

export const FactionAvatar: React.FC<FactionAvatarContentProps> = ({
  asLink,
  ...props
}) => {
  if (asLink)
    return (
      <FactionLink name={props.factionName}>
        <FactionAvatarContent {...props} />
      </FactionLink>
    );

  return <FactionAvatarContent {...props} />;
};
